export interface CapturedError {
  time: number;
  message: string;
}

const list: CapturedError[] = [];
const listeners: Array<() => void> = [];

export function pushError(message: string): void {
  list.push({ time: Date.now(), message: message.slice(0, 300) });
  if (list.length > 20) list.shift();
  listeners.forEach((f) => f());
}

export function errors(): readonly CapturedError[] {
  return list;
}

export function onErrorsChanged(f: () => void): void {
  listeners.push(f);
}

/** Erorile JS apar în overlay: pe iPhone nu avem consola Safari fără Mac. */
export function installErrorCapture(): void {
  window.addEventListener('error', (e) => pushError(`${e.message} (${(e.filename || '').split('/').pop()}:${e.lineno})`));
  window.addEventListener('unhandledrejection', (e) => pushError(`Promise: ${e.reason instanceof Error ? e.reason.message : String(e.reason)}`));
}
